import { Component, Input } from '@angular/core';
import { AlertController, NavController } from '@ionic/angular';
import { AccountService } from 'src/app/shared/services/account.service';

@Component({
  selector: 'app-create-job-button',
  templateUrl: './create-job-button.component.html',
  styleUrls: ['./create-job-button.component.scss'],
})
export class CreateJobButtonComponent {
  @Input() buttonText = 'Create Last Minute Job';

  // The query params to include when navigating to the LMJ form.
  @Input() queryParams = {};

  accountsCallInProgress = true;

  canCreateJob = false;

  constructor(
    private navCtrl: NavController,
    private accountService: AccountService,
    private alertCtrl: AlertController,
  ) {
    this.accountService
      .account()
      .then((account) => {
        this.canCreateJob = account ? account.canCreateLmj : false;
      })
      .catch()
      .then(() => {
        this.accountsCallInProgress = false;
      });
  }

  createJob() {
    if (this.canCreateJob) {
      this.navCtrl.navigateForward('flex/jobs/create/form', {
        queryParamsHandling: 'merge',
        queryParams: this.queryParams,
      });
    } else {
      this.showError();
    }
  }

  async showError() {
    const alert = await this.alertCtrl.create({
      header: 'Incomplete profile',
      message: 'Please complete your profile before posting a Last Minute job',
      buttons: [
        {
          text: 'Ok',
        },
      ],
    });

    await alert.present();
  }
}
